import { render, staticRenderFns } from "./customer_sorting.vue?vue&type=template&id=5894404f&scoped=true"
import script from "./customer_sorting.vue?vue&type=script&lang=js"
export * from "./customer_sorting.vue?vue&type=script&lang=js"
import style0 from "./customer_sorting.vue?vue&type=style&index=0&id=5894404f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5894404f",
  null
  
)

export default component.exports